module.exports = __webpack_public_path__ + "static/img/qrcode_testing.9d83ca11.png";